import Component from '@glimmer/component';
import { type WrFormRadioControlComponentSignature } from '../../../../components/form/controls/radio.gts';
import ChoiceField, {
  type ChoiceFieldSig
} from '../../../../components/form/fields/choice.gts';

export interface WrFormRadioFieldComponentSignature {
  Element: WrFormRadioControlComponentSignature['Element'];
  Args: {
    label?: ChoiceFieldSig['Args']['label'];
    variant?: ChoiceFieldSig['Args']['variant'];
    selectedValue?: string;
    value: WrFormRadioControlComponentSignature['Args']['value'];
    onChange?: WrFormRadioControlComponentSignature['Args']['onChange'];
    name: string;
  };
}

export default class WrFormRadioFieldComponent extends Component<WrFormRadioFieldComponentSignature> {
  get isChecked() {
    return this.args?.selectedValue === this.args.value;
  }

  <template>
    <ChoiceField
      @variant={{@variant}}
      @label={{@label}}
      @isChecked={{this.isChecked}}
      as |field|
    >
      <field.Radio
        name={{@name}}
        @value={{@value}}
        @isChecked={{this.isChecked}}
        @onChange={{@onChange}}
        ...attributes
      />
    </ChoiceField>
  </template>
}
